import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

window.addEventListener('frame-ready', init)

function init() {

    const section = document.querySelector('.BusinessPage');
    if(!section) {
        return;
    }

    const blocks = Array.from(section.querySelectorAll('.infoblock--value'))

    if(blocks.length > 0) {

        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        function number_format(number, decimals, dec_point, thousands_sep) {
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                toFixedFix = function (n, prec) {
                    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                    var k = Math.pow(10, prec);
                    return Math.round(n * k) / k;
                },
                s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }

        blocks.forEach( block => {
            let to = parseInt(block.innerText.replace(/\D/g,''));
            let counter = { var: 0 }
            block.innerText = '0'

            gsap.timeline({
                scrollTrigger: {
                    trigger: block,
                    start: 'top 90%'
                },
                onUpdate: function() {
                    let nwc = parseInt(counter.var)
                    block.innerText = number_format(nwc + '', 0)
                }
            })
            .to(counter, { var: to, duration: 1, ease: 'power2' })
        })
    }
}
